<template>
  <div class="shop-item">
    <div class="add-remove">
      <vs-button @click="$emit('add')" color="success" size="small" icon-pack="feather" icon="icon-plus"></vs-button>
      <vs-button class="ml-1" @click="$emit('remove')" color="danger" size="small" icon-pack="feather"
        icon="icon-minus"></vs-button>
    </div>
    <span class="count">{{ product.unit }} ×</span>
    <span class="name">{{ product.product.title }}</span>
    <div class="spacer"></div>
    <span class="price">{{ product.price.toString().numberFormat() }}</span>
    <span class="rial">ریال</span>
  </div>
</template>

<script>
export default {
  name: "ShopItem",
  props: {
    product: {
      type: Object,
      required: true
    }
  },
};
</script>

<style scoped lang="scss">
.shop-item {
  display: flex;
  align-items: center;

  &+.shop-item {
    margin-top: 15px;
  }

  .add-remove {
    display: flex;
    margin-right: 5px;
  }

  .count {
    color: #878986;
    font-size: 13px;
    margin-right: 5px;
  }

  .name,
  .price {
    font-weight: 600;
    color: #000000;
  }

  .spacer {
    flex: 1;
  }

  .rial {
    color: #a7a7a7;
    margin-left: 5px;
    font-size: 10px;
  }
}
</style>
